export type Task = {
  id: string;
  getIsBlocked?: () => boolean;
  hasFinished?: boolean;
  hasStarted?: boolean;
  hasError?: boolean;
  run: () => Promise<void | undefined> | undefined;
};

export type WorkerOptions = {
  onTaskStarted?: (taskId: Task['id']) => void;
  onTaskFinished?: (taskId: Task['id']) => void;
  onTaskError?: (taskId: Task['id'], error: unknown) => void;
};

export class Worker {
  private id: number;
  private isBusy: boolean;
  private options: WorkerOptions = {};

  constructor(id: number, options?: WorkerOptions) {
    this.id = id;
    this.options = options || {};
    this.isBusy = false;
  }

  public resetWorker = () => {
    this.isBusy = false;
  };

  public getIsBusy = () => this.isBusy;

  public getWorkerId = () => this.id;

  public async runTask(task: Task) {
    try {
      this.isBusy = true;
      task.hasStarted = true;
      this.options?.onTaskStarted?.(task.id);
      await task.run();
      this.isBusy = false;
      task.hasFinished = true;
      this.options?.onTaskFinished?.(task.id);
    } catch (error) {
      this.isBusy = false;
      task.hasError = true;
      this.options?.onTaskError?.(task.id, error);
    }
  }
}
